import DateBox from 'devextreme-react/date-box';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import moment from 'moment';
import React, { useEffect, useMemo, useRef,useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tab, Modal, Transition } from 'semantic-ui-react';
import { cauHinhMaHocSinhApi } from '../../api/cauhinh_mahocsinh_api';
import { chienDichApi } from '../../api/chienDichApi';
import { formEditorApi } from '../../api/formEditorApi';
import { formItemApi } from '../../api/formItemApi';
import { formRegisterApi } from '../../api/formRegisterApi';
import { HOCSINH_API_ENDPOINT, hocSinhApi } from '../../api/hocsinh_api';
import { quanHeGiaDinhApi } from '../../api/quanHeGiaDinhApi';
import { appCached, appCachedKeys } from '../../appCached';
import { DefaultButton, PrimaryButton } from '../../components/editor/button';
import ComboboxChienDich from '../../components/editor/cmb_chiendich';
import ComboTuVanVien from '../../components/editor/cmd_tuvanvien';
import { HttpMethod, useCommonContext } from '../../contexts/common';
import { showNotify } from '../../helpers/toast';
import AttendanceModal from './attendance-modal/AttendanceModal';
import DetailGrid from './detail-grid/DetailGrid';
import DetailModal from './detail_modal';
import FormResultImportModal from './import-modal/FormResultImportModal';
import SummaryPivotGrid from './pivot-grid/SummaryPivotGrid';
import SendEmailInviteModal from './send-email-invite-modal';
import SendEmailMoiGhiDanhModal from './send-email-moi-ghi-danh-modal';
import { khoiApi } from '../../api/dm_khoi_api';
import _ from 'lodash'
import { phuHuynhApi } from '../../api/phuHuynhApi';
import { userApi } from '../../api/userApi';
import { PhuHuynhSelectTuVanVienModal } from '../phu-huynh/select-tuvanvien-modal';
import HocSinhProfile from '../hoc-sinh-profile/HocSinhProfile';
import SendEmailModal from './send-email/SendEmailModal';
import SendSmsModal from './send-sms/SendSmsModal';
import AddCampaignModal from './add-campaign/AddCampaignModal';
import { nguonBietToiApi } from "../../api/nguonBietToiApi.js";
import SelectBox from "devextreme-react/select-box";
import DropDownButton from 'devextreme-react/drop-down-button';
import { actionTypes, hocSinhIniState, hocSinhPageStastus, hocSinhReducer } from '../hoc-sinh/hocSinhReducer';
import { HocSinhChangeStatusModal } from '../hoc-sinh/change-status-modal';

const FormRegisterResultPage = () => {
  const { canAccessTo } = useCommonContext();

  const [ts_form_register_results, set_ts_form_register_results] = useState([]);
  const [ts_form_register_result_details, set_ts_form_register_result_details] =
    useState([]);
  const [dm_chiendichs, set_dm_chiendichs] = useState([]);
  const [dm_chiendich_selected, set_dm_chiendich_selected] = useState({ id: 0 });
  const [ts_form_items, set_ts_form_items] = useState([]);
  const [ts_form_items_header, set_ts_form_items_header] = useState([]);
  const [ts_form_items_edit, set_ts_form_items_edit] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowAttendanceModal, setisShowAttendanceModal] = useState(false);
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [isShowSendEmailModal, setIsShowSendEmailModal] = useState(false);
  const [isShowAddCampaignModal, setIsShowAddCampaignModal] = useState(false);
  const [isShowSendEmailMoiGhiDanhModal, setIsShowSendEmailMoiGhiDanhModal] = useState(false);
  const [isShowImportModal, setIsShowImportModal] = useState(false);
  const [filter, setFilter] = useState();
  const { dm_coso_id } = useSelector(x => x.coSo)
  const { nam_hoc } = useSelector(x => x.namHoc)
  const { user } = useSelector((x) => x.auth);
  const [tuVanViens, setTuVanViens] = useState([]);
  const [tuvanvien_selected, set_tuvanvien_selected] = useState('');
  const [nguon_selected, set_nguon_selected] = useState('');
  const [list_dm_nguonbiettoi, set_list_dm_nguonbiettoi] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [formEditor, setFormEditor] = useState([]);
  const [showInSertModal, setShowInSertModal] = useState(false);
  const [registerResult, setRegisterResult] = useState({ id: 0 });
  const [isShowEmailDetailModal, setIsShowEmailDetailModal] = useState(false);
  const [isShowSmslDetailModal, setIsShowSmsDetailModal] = useState(false);
  const grid = useRef();
  const { translate } = useCommonContext();
  const [state, dispatch] = useReducer(hocSinhReducer, {
		...hocSinhIniState
	});
  const {
		isShowChangeStatusModal,
	} = state;

  useEffect(() => {
    handleReloadChienDichs();
    getFormEditor();
  }, [nam_hoc, dm_coso_id]);

  useEffect(() => {
		hanleLoadTuVanViens();
	}, []);
	const hanleLoadTuVanViens = async () => {
		const res = await userApi.SelectTuVanVien(dm_coso_id);
		if (res.is_success) {
      res.data.forEach(element => {
          element.name = element.full_name;
      });
			setTuVanViens(res.data);
		}
	};

  const getFormEditor = async () => {
    const res = await formEditorApi.SelectByCoSo(dm_coso_id);
    if (res.is_success) {
      setFormEditor(res.data)

    }
  }
  useEffect(() => {
    get_list_dm_nguonbiettoi();
  }, []);
  useEffect(() => {
    // console.log(tuvanvien_selected)
    handeReloadData();
  }, [tuvanvien_selected, nam_hoc]);
  useEffect(() => {
    const cachedData = appCached.GET(appCachedKeys.DM_CHIENDICH_SELECTED);
    if (cachedData && cachedData.id > 0 && dm_chiendichs.find(x => x.id == cachedData.id)) {
      set_dm_chiendich_selected(dm_chiendichs.find(x => x.id == cachedData.id));
    }
  }, [dm_chiendichs])
  useEffect(() => {
    handeReloadData();
    if (dm_chiendich_selected && dm_chiendich_selected.id > 0) {
      appCached.SET(appCachedKeys.DM_CHIENDICH_SELECTED, dm_chiendich_selected)
    } else {
      appCached.DELETE(appCachedKeys.DM_CHIENDICH_SELECTED)
    }
  }, [dm_chiendich_selected, nguon_selected]);
  const handeReloadData = async () => {
    if (canAccessTo('api/form-result/co-so/{dm_coso_id}/chien-dich/{dm_chiendich_id}', HttpMethod.GET)) {
      setIsLoading(true);
      if (grid.current) grid.current.instance.beginCustomLoading("Đang tải dữ liệu");
      await handleReloadFormItems();
      await handleReloadResults();
     
      setIsLoading(false);
      if (grid.current) grid.current.instance.endCustomLoading("Đang tải dữ liệu");
    }
  };

  const get_list_dm_nguonbiettoi = async () => {
    const res = await nguonBietToiApi.SelectAll();
    if (res.is_success) {
      if (dm_coso_id > 0) {
        res.data = res.data.filter(x => x.dm_coso_id === dm_coso_id);
      }
      set_list_dm_nguonbiettoi(res.data);
    }
  };

  const handleReloadChienDichs = async () => {
    const res = await chienDichApi.SelectByCoSo(dm_coso_id);
    if (res.is_success) {
      set_dm_chiendichs(res.data);
    }
  };
  const handleReloadFormItems = async () => {
    if (dm_chiendich_selected && dm_chiendich_selected.id > 0 && dm_chiendich_selected.ts_form_id > 0) {
      const res = await formItemApi.Select(dm_chiendich_selected.ts_form_id);
      if (res.is_success) {
        set_ts_form_items(res.data);
        set_ts_form_items_header(res.data);
      }
    } else {
      const res = await formItemApi.Select(0);
      if (res.is_success) {
        res.data.forEach(element => {
          if(element.ts_form_editor_id == 2032){
            element.index_order = 1;
          }
        });
        const data = _.groupBy(res.data, 'ts_form_editor_id')
        const _data = Object.keys(data).map((value) => data[value][0])
        _data.sort((a, b) => a.index_order - b.index_order);
        set_ts_form_items_header(_data);
        set_ts_form_items(res.data);
      }
    }
  };
  const handleReloadResults = async () => {
    if (dm_chiendich_selected != undefined) {
      const res = await formRegisterApi.Select(dm_coso_id, dm_chiendich_selected.id, nam_hoc);
      // TOTO dua loc xuong DB
      if (res.is_success) {
        if (tuvanvien_selected) {
          res.data = res.data.filter(x => (x.tu_van_vien_bo === tuvanvien_selected || x.tu_van_vien_me === tuvanvien_selected));
        }
        set_ts_form_register_results(res.data);
        console.log(res.data);
        await handleReloadResultDetails(res.data);
      }
    }

  };
  const handleReloadResultDetails = async (rs) => {
    var datas = [];
    rs.forEach(x => {
        datas.push(x.id);
    });
    const res = await formRegisterApi.SelecDetailListByResult({results: datas, dm_coso_id: dm_coso_id});
    if (res.is_success) {
      set_ts_form_register_result_details(res.data);
    }
  };
  const isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  const dataSource = useMemo(() => {
    if (!isLoading) {
      const source = ts_form_register_results.map((x) => {
        let item = { ...x };
        const details = ts_form_register_result_details.filter(
          (y) => y.ts_form_register_result_id == x.id
        );
        details.forEach((y) => {
          try {
            item[`T_${y.ts_form_item_id}`] = isJsonString(y.text) ? JSON.parse(y.text).join(',\n') : y.text;
            item[`Id_${y.ts_form_item_id}`] = y.id;
            item[`TC_${y.ts_form_editor_id}`] = isJsonString(y.text) ? JSON.parse(y.text).join(',\n') : y.text;
          } catch (e) {
            item[`T_${y.ts_form_item_id}`] = y.text;
            item[`Id_${y.ts_form_item_id}`] = y.id;
            item[`TC_${y.ts_form_editor_id}`] = y.text;
          }
          item[`TC_2032`] = x.ma_hs;
        });
        return item;
      });

      // console.log({
      //   source,
      //   filter,
      //   xxx: source.filter(x =>
      //     (!filter?.tu_ngay || x.register_date >= filter.tu_ngay)
      //     &&
      //     (!filter?.den_ngay || x.register_date <= filter.den_ngay)
      //   )
      // });
      return source.filter(x =>
        (!filter?.tu_ngay || x.register_date >= filter.tu_ngay)
        &&
        (!filter?.den_ngay || x.register_date < filter.den_ngay)
        && 
        (nguon_selected == null || nguon_selected == '' || x.TC_2008 == nguon_selected)
      );
    }
    return [];
  }, [
    isLoading,
    ts_form_items,
    ts_form_register_result_details,
    ts_form_register_results,
    filter
  ]);


  const onSelectionChanged = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys)
  }

  const btnEdit_click = (data) => {
    var details = [];
    if (dm_chiendich_selected && dm_chiendich_selected.id > 0) {
      details = ts_form_items;
    }else{
      details = ts_form_items.filter(
        (y) => data[`Id_${y.id}`] != null
      );
    }
    set_ts_form_items_edit(details);
    setSelectedItem({ data })
    setIsShowDetailModal(true);
  };

  const btnNewHS_click = (data) => {
    setRegisterResult(data);
  };

  const updateInvite = async (value) => {
    return await formRegisterApi.UpdateInvite(
      {
        is_update_invite: true,
        id: value.ts_form_register_result_id
      }
    );
  }

  const updateStatus = async (value, status_id) => {
    return await formRegisterApi.UpdateStatus(
      {
        status_id: status_id,
        id: value.ts_form_register_result_id
      }
    );
  }

  const insertHS = async (value) => {
    if (value.ho_ten == null) {
      return {
        text: translate(`Họ tên học sinh bị trống`),
        type: 'error',
      };
    }
    if (value.dm_khoi_id == null || isNaN(value.dm_khoi_id)) {
      return {
        text: translate(`Khối học sinh ${value.ho_ten} bị trống`),
        type: 'error',
      };
    }
    if (value.dm_he_id == null) {
      return {
        text: translate(`Hệ học sinh ${value.ho_ten} bị trống`),
        type: 'error',
      };
    }
    if (value.ngay_sinh_timestamp == null) {
      return {
        text: translate(`Ngày sinh học sinh ${value.ho_ten} bị trống`),
        type: 'error',
      };
    }
    const resKhoi = await khoiApi.Detail(value.dm_khoi_id);
    var dm_truong_id = value.dm_truong_id != null ? value.dm_truong_id : 0;
    if (resKhoi.is_success) {
      dm_truong_id = resKhoi.data.dm_truong_id;
    }

    var namHoc = value.nam_hoc != null ? value.nam_hoc : nam_hoc;
    const resCauHinh = await cauHinhMaHocSinhApi.SelectByCoSo(dm_coso_id);
    if (resCauHinh.is_success) {
      if (resCauHinh.data.length > 0) {
        const filterByNamHoc = resCauHinh.data.filter((x) => x.nam_hoc == namHoc && x.is_active == true);
        if (filterByNamHoc != null && filterByNamHoc.length > 0) {
          var gioiHanTren = Math.pow(10, filterByNamHoc[0].so_kytu_tutang) - 1;
          if (filterByNamHoc[0].so_hientai >= 0 && filterByNamHoc[0].so_hientai <= gioiHanTren) {
            var formDataSubmit = {
              id: 0,
              nam_hoc: namHoc,
              nam_nhap_hoc: namHoc,
              ho_ten: value.ho_ten,
              ngay_sinh_timestamp: value.ngay_sinh_timestamp,
              ngay_nhap_hoc_timestamp: new Date().getTime(),
              dm_gioitinh_id: value.dm_gioitinh_id ? value.dm_gioitinh_id : 1,
              dm_he_id: value.dm_he_id,
              dm_coso_id: dm_coso_id,
              dm_dantoc_id: 1,
              dm_tongiao_id: 1,
              dm_khoi_id: value.dm_khoi_id,
              dm_truong_id: dm_truong_id,
              truong_hoc_cu: value.truong_hoc_cu,
              dm_nguonbiettoi_id: value.dm_nguonbiettoi_id ? value.dm_nguonbiettoi_id : 0,
              dm_quoctich_id: value.dm_quoctich_id ? value.dm_quoctich_id : 1,
              dia_chi_tt: value.dia_chi_tt,
              dia_chi_noi_sinh: value.dia_chi_noi_sinh,
              que_quan: value.que_quan,
              so_dien_thoai_bo: value.dien_thoai_cha,
              so_dien_thoai_me: value.dien_thoai_me
            };
            var res = await hocSinhApi.Insert(formDataSubmit);
            // console.log(res);
            if (res.is_success) {
              if (value.dien_thoai_cha != null && value.dien_thoai_cha != "") {
                if (value.dien_thoai_cha.toString().startsWith('0') && value.dien_thoai_cha.toString().length == 10) {
                  const formDataSubmit = {
                    dien_thoai: value.dien_thoai_cha,
                    ts_hocsinh_id: res.data,
                    dm_coso_id: dm_coso_id,
                    dm_quanhe_id: 1
                  };
                  await quanHeGiaDinhApi.Insert(formDataSubmit);
                }
              }
              if (value.dien_thoai_me != null && value.dien_thoai_me != "") {
                if (value.dien_thoai_me.toString().startsWith('0') && value.dien_thoai_me.toString().length == 10) {
                  const formDataSubmit = {
                    dien_thoai: value.dien_thoai_me,
                    ts_hocsinh_id: res.data,
                    dm_coso_id: dm_coso_id,
                    dm_quanhe_id: 2
                  };
                  await quanHeGiaDinhApi.Insert(formDataSubmit);
                }
              }
              if (value.dien_thoai_giam_ho != null && value.dien_thoai_giam_ho != "") {
                if (value.dien_thoai_giam_ho.toString().startsWith('0') && value.dien_thoai_giam_ho.toString().length == 10) {
                  const formDataSubmit = {
                    dien_thoai: value.dien_thoai_giam_ho,
                    ts_hocsinh_id: res.data,
                    dm_coso_id: dm_coso_id,
                    dm_quanhe_id: 3
                  };
                  await quanHeGiaDinhApi.Insert(formDataSubmit);
                }
              }
              await formRegisterApi.UpdateHocSinh(
                {
                  ts_hocsinh_id: res.data,
                  id: value.ts_form_register_result_id
                }
              );
              // await formRegisterApi.UpdateResult({ ts_hocsinh_id: res.data, id: value.ts_form_register_result_id });
              return { text: translate('Cập nhật thành công '), type: 'success' };
            } else {
              return { text: res.message, type: 'error' };
            }
            return res;
          } else {
            return {
              text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${namHoc} `),
              type: 'error',
            };
          }
        } else {
          return {
            text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${namHoc} `),
            type: 'error',
          };
        }
      } else {
        return {
          text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${namHoc} `),
          type: 'error',
        };
      }
    } else {
      return {
        text: translate(`Vui lòng xem lại cấu hình mã học sinh năm học ${namHoc} `),
        type: 'error',
      };
    }
    return null;
  }

  const onUpdateInvite = async () => {
    var datas = [];
    selectedRowKeys.forEach(x => {
      try {
        let _data = {
          ts_form_register_result_id: x
        };
        datas.push(_data);
      } catch (error) {
      }
    });
    try {
      const res = await Promise.all(datas.map((value) => {
        return updateInvite(value);
      }));
      if (res) {
        showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
        setSelectedRowKeys([]);
        handeReloadData();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const onAddHocSinhClick = async () => {
    var datas = [];
    selectedRowKeys.forEach(x => {
      const _listData = ts_form_register_result_details.filter(
        (y) => y.ts_form_register_result_id == x
      );

      try {
        let _data = {
          nam_hoc: null,
          ho_ten: null,
          ngay_sinh_timestamp: null,
          dm_gioitinh_id: null,
          dm_he_id: null,
          dm_khoi_id: null,
          dm_truong_id: null,
          truong_hoc_cu: null,
          dm_nguonbiettoi_id: null,
          dm_quoctich_id: null,
          nam_hoc: null,
          dia_chi_tt: null,
          dia_chi_noi_sinh: null,
          que_quan: null,
          ts_form_register_result_id: null,
          dien_thoai_cha: null,
          dien_thoai_me: null,
          dien_thoai_giam_ho: null
        };
        _listData.forEach(element => {
          _data.ts_form_register_result_id = element.ts_form_register_result_id;
          switch (element.ts_form_editor_id) {
            case 2000:
              _data.ho_ten = element.value;
              break;
            case 2001:
              _data.dm_gioitinh_id = parseInt(element.value);
              break;
            case 2002:
              _data.ngay_sinh_timestamp = element.value ? moment(element.value, 'DD/MM/YYYY').toDate().getTime() : 0;
              break;
            case 2003:
              _data.dm_quoctich_id = parseInt(element.value);
              break;
            case 2004:
              _data.dm_truong_id = parseInt(element.value);
              break;
            case 2005:
              _data.dm_khoi_id = parseInt(element.value);
              break;
            case 2006:
              _data.dm_he_id = parseInt(element.value);
              break;
            case 2007:
              _data.truong_hoc_cu = element.value;
              break;
            case 2008:
              _data.dm_nguonbiettoi_id = parseInt(element.value);
              break;
            case 2009:
              _data.nam_hoc = element.value;
              break;
            case 2010:
              _data.dia_chi_tt = element.value;
              break;
            case 2011:
              _data.dia_chi_noi_sinh = element.value;
              break;
            case 2012:
              _data.que_quan = element.value;
              break;
            case 2015:
              _data.dien_thoai_cha = element.value;
              break;
            case 2021:
              _data.dien_thoai_me = element.value;
              break;
            case 2030:
              _data.dien_thoai_giam_ho = element.value;
              break;
            default:
              break;
          }
        });
        datas.push(_data);
      } catch (error) {
        console.log(error);
      }
    });
    try {
      const results = [];
      for (const value of datas) {
        const result = await insertHS(value);
        results.push(result);
      }
      // const res = await Promise.all(datas.map((value) => {
      //   return insertHS(value);
      // }));
      if (results) {
        var success = true;
        results.forEach(x => {
          if (x.type == 'error') {
            showNotify({ text: x.text, type: x.type });
            success = false;
          }
        });
        if (success) {
          showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
        }
        setSelectedRowKeys([]);
        handeReloadData();
      }
    } catch (error) {
      console.log(error);
    }

  }

  const handleUpdateTuVanVien = async (user_id) => {
    const _phuhuynh = []
    const _data = ts_form_register_results.filter((val) => selectedRowKeys.includes(val.id));
    const _listData = ts_form_register_result_details.filter(
      (y) => selectedRowKeys.includes(y.ts_form_register_result_id)
    );
    // console.log(_listData);
    var update = true;
    _data.forEach((val) => {
      var havePh = false;
      if (val.ts_phuhuynh_id > 0) {
        _phuhuynh.push(val.ts_phuhuynh_id);
        havePh = true;
      }
      if (val.ts_phuhuynh_me_id > 0) {
        _phuhuynh.push(val.ts_phuhuynh_me_id);
        havePh = true;
      }
      if (val.ts_phuhuynh_gh_id > 0) {
        _phuhuynh.push(val.ts_phuhuynh_gh_id);
        havePh = true;
      }
      if(!havePh){
        const details = _listData.filter(
          (y) => y.ts_form_register_result_id == val.id
        );
        var sdt = "";
        details.forEach((y) => {
            if(y.ts_form_editor_id==2015 || y.ts_form_editor_id==2021){
              sdt = y.value;
              
            }
        });
        if(sdt==""){
          showNotify({ text: "Các bản ghi đã chọn có bản ghi chưa có thông tin phụ huynh!", type: 'error' });
          update = false;
          setShowInSertModal(false);
        }
      }
    })
    if (_phuhuynh.length > 0 && update) {
      const res = await phuHuynhApi.UpdateTuVanVien({
        ts_phuhuynh_ids: _phuhuynh,
        user_id,
        dm_coso_id
      });
      if (res.is_success) {
        showNotify({ text: res.message, type: 'success' });
        setShowInSertModal(false)
        handleReloadResults()
      } else {
        showNotify({ text: res.message, type: 'error' });
      }
    }

  }

  const handleChangeStatus = async (dm_trangthaihocsinh_id) => {
        dispatch({
          type: actionTypes.CLOSE_CHANGE_STATUS_MODAL,
        });
        var datas = [];
        selectedRowKeys.forEach(x => {
          try {
            let _data = {
              ts_form_register_result_id: x
            };
            datas.push(_data);
          } catch (error) {
          }
        });
        try {
          const res = await Promise.all(datas.map((value) => {
            return updateStatus(value, dm_trangthaihocsinh_id);
          }));
          if (res) {
            showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
            setSelectedRowKeys([]);
            handeReloadData();
          }
        } catch (error) {
          console.log(error);
        }
      }
	
  // console.log(dataSource)
  const panes = [
    {
      menuItem: translate(`Danh sách`), render: () => <Tab.Pane>
        <DetailGrid
          grid={grid}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={onSelectionChanged}
          ts_form_items={ts_form_items_header}
          dataSource={dataSource}
          dm_chiendichs={dm_chiendichs}
          btnEdit_click={btnEdit_click}
          btnNewHS_click={btnNewHS_click}
          viewMaHs={dm_chiendich_selected && dm_chiendich_selected.id > 0}
        />
      </Tab.Pane>
    },
    { menuItem: `${translate("Pivot grid")}`, render: () => <Tab.Pane><SummaryPivotGrid dataSource={dataSource} /></Tab.Pane> },
  ]

  const checkEnableButton = (key1, key2, key3) => {
    if (selectedRowKeys.length == 0) return true;
    const _listdata = dataSource.filter((val) => selectedRowKeys.includes(val.id))
    if (_listdata.length > 0) {
      return _listdata.every((val) => _.get(val, key1, '') == "" && _.get(val, key2, '') == "" && _.get(val, key3, '') == "")
    }
    return true
  }
  return (
    <React.Fragment>
      <Transition
        animation="scale"
        visible={true}
        duration={200}
        transitionOnMount={true}
      >
        <div>
          <div className="row">
            <div className="col-md-12 padding-top-1rem padding-left-2rem">
              <Toolbar>
                <Item
                  location="before"
                  render={() => {
                    return <h3>{translate('Kết quả khảo sát')}</h3>;
                  }}
                />
                <Item
                  location="after"
                  render={() => {
                    return (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ComboboxChienDich
                          width={250}
                          value={dm_chiendich_selected?.id || 0}
                          showClearButton={true}
                          onValueChanged={(id, data) => {
                            set_dm_chiendich_selected(data ?? { id: 0 });

                          }}
                        />
                      </div>
                    );
                  }}
                />
                <Item
                  location="after"
                  render={() => {
                    return (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ComboTuVanVien
                         width={250}
                          value={tuvanvien_selected}
                          valueExpr={'full_name'}
                          dm_coso_id={dm_coso_id}
                          showClearButton={true}
                          onValueChanged={(data) => {
                            set_tuvanvien_selected(data);
                          }}
                        />
                      </div>
                    );
                  }}
                />
                <Item
                  location="after"
                  render={() => {
                    return (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SelectBox
                          stylingMode="outlined"
                          width={250}
                          showClearButton={true}
                          placeholder={translate('Chọn nguồn biết tới')}
                          value={nguon_selected}
                          dataSource={list_dm_nguonbiettoi}
                          displayExpr="nguon_biet_toi"
                          valueExpr="nguon_biet_toi"
                          noDataText={translate('Không có dữ liệu')}
                          onValueChanged={(e) => {
                            if (!e.event) return;
                            set_nguon_selected(e.value);
                          }}
                        />
                      </div>
                    );
                  }}
                />
                <Item
                  location="after"
                  render={() => {
                    return (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label style={{ fontWeight: "bold", marginRight: 10 }}>Từ ngày</label>
                        <DateBox stylingMode='outlined' width={150}
                          displayFormat="dd/MM/yyyy"
                          showClearButton
                          onValueChanged={(e) => {
                            setFilter({
                              ...filter,
                              tu_ngay: e.value ? moment(e.value).format("yyyy-MM-DD") : undefined
                            })
                          }} />
                      </div>
                    );
                  }}
                />
                <Item
                  location="after"
                  render={() => {
                    return (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label style={{ fontWeight: "bold", marginRight: 10 }}>Đến ngày</label>
                        <DateBox stylingMode='outlined' width={150}
                          displayFormat="dd/MM/yyyy"
                          showClearButton
                          onValueChanged={(e) => {
                            setFilter({
                              ...filter,
                              den_ngay: e.value ? moment(e.value).add("day", 1).format("yyyy-MM-DD") : undefined
                            })
                          }} />
                      </div>
                    );
                  }}
                />
              </Toolbar>
              <Toolbar className="bg-background">

                <Item location={"before"}>
                  <div>
                    Tổng số lượng: {dataSource.length}
                  </div>
                </Item>
                <Item
                  location="after"
                  render={() => {
                    return (
                      <div>
                        <PrimaryButton text={'Thêm vào chiến dịch'}
                          disabled={selectedRowKeys.length == 0}
                          icon={'fas fa-plus'} onClick={() => { setIsShowAddCampaignModal(true) }} />
                        {' '}
                        {canAccessTo(HOCSINH_API_ENDPOINT, HttpMethod.POST) && (
                          <PrimaryButton text={'Cập nhật thông tin vào học sinh'}
                            disabled={selectedRowKeys.length == 0 || dataSource.some((val) => val.ts_hocsinh_id > 0 && selectedRowKeys.includes(val.id))}
                            icon={'fas fa-plus'} onClick={onAddHocSinhClick} />
                        )}
                        {' '}
                        <PrimaryButton text={'Cập nhật đã tham gia'}
                          disabled={selectedRowKeys.length == 0}
                          icon={'fas fa-plus'} onClick={onUpdateInvite} />
                        {' '}
                        {canAccessTo(HOCSINH_API_ENDPOINT, HttpMethod.POST) && (
                          <PrimaryButton text={'Gửi email'}
                            disabled={checkEnableButton('TC_2014', 'TC_2020', 'TC_2026')}
                            icon={'fas fa-plus'} onClick={() => { setIsShowEmailDetailModal(true) }} />
                        )}
                        {' '}
                        {canAccessTo(HOCSINH_API_ENDPOINT, HttpMethod.POST) && (
                          <PrimaryButton text={'Gửi sms'}
                            disabled={checkEnableButton('TC_2015', 'TC_2021', 'TC_2030')}
                            icon={'fas fa-plus'} onClick={() => { setIsShowSmsDetailModal(true) }} />
                        )}
                        {' '}
                        {canAccessTo('api/phu-huynh/tu-van-vien', HttpMethod.PUT) && <DefaultButton
                          disabled={selectedRowKeys.length == 0}
                          text={"Gán CSKH"}
                          icon="fas fa fa-check"
                          onClick={() => {
                            setShowInSertModal(true)
                          }} />}
                        {' '}
                        {/* {canAccessTo('api/form-result/import/co-so/{dm_coso_id}', HttpMethod.PUT) && */}
                        <PrimaryButton
                          text={`Đổi trạng thái`}
                          disabled={selectedRowKeys.length <= 0}
                          onClick={() => { dispatch({
                            type: actionTypes.SHOW_CHANGE_STATUS_MODAL,
                          });}}
                        />
                        <DropDownButton
                            text="Excel"
                            icon="overflow"
                            className="PrimaryDropDownButton"
                                          dropDownOptions={{ width: 130 }}
                            stylingMode='outlined'
                                          displayExpr="name"
                                          keyExpr="id"
                                          items={[
                                            { id: 1, name: 'Import Excel', icon: 'xlsfile' },
                                            { id: 2, name: 'Xuất Excel', icon: 'xlsfile' },
                                          ]}
                                          onItemClick={(e) => {
                              if (e.itemData.id == 1)
                                setIsShowImportModal(true);
                              if (e.itemData.id == 2)
                                grid.current.instance.exportToExcel();
                            }}
                          />
                        {/* <DefaultButton icon={"fas fa-file-excel"}
                          text="Import Excel"
                          disabled={false}
                          onClick={() => {
                            setIsShowImportModal(true)
                          }} /> */}
                        {' '}
                        {/* {canAccessTo('api/form-result-detail', HttpMethod.PUT) &&
                        <PrimaryButton onClick={() => {
                          setisShowAttendanceModal(true)
                        }}
                          disabled={!dm_chiendich_selected || dm_chiendich_selected.id <= 0}
                          text="Cập nhật Kết quả"
                          icon={"fas fa-tasks"}
                        />
                        {/* }{' '}
                        {canAccessTo('api/form-result/send-invite', HttpMethod.POST) &&
                          <PrimaryButton text={"Gửi email mời tham gia"}
                            icon="fas fa-paper-plane"
                            disabled={!dm_chiendich_selected || dm_chiendich_selected.id <= 0}
                            onClick={() => { setIsShowSendEmailModal(true) }}
                          />} {' '}
                        {canAccessTo('api/form-result/send-moi-ghi-danh', HttpMethod.POST) &&
                          <PrimaryButton text={"Gửi email mời ghi danh"}
                            icon="fas fa-paper-plane"
                            disabled={!dm_chiendich_selected || dm_chiendich_selected.id <= 0}
                            onClick={() => { setIsShowSendEmailMoiGhiDanhModal(true) }}
                          />
                        } */}

                        {' '}
                        {/* <DefaultButton onClick={() => {
                          grid.current.instance.exportToExcel();
                        }}
                          text="Xuất excel"
                          icon={"fas fa-file-excel"}
                        /> */}
                      </div>
                    );
                  }}
                />
              </Toolbar>
            </div>
            <div className="col-md-12">
              <Tab panes={panes} />
              {/* <SummaryPivotGrid dataSource={dataSource} />

              <DetailGrid
                grid={grid}
                ts_form_items={ts_form_items}
                dataSource={dataSource}
                dm_chiendichs={dm_chiendichs}
                btnEdit_click={btnEdit_click}
              /> */}
            </div>
          </div>
          {isShowAttendanceModal &&
            <AttendanceModal
              dataSource={dataSource}
              ts_form_items={ts_form_items}
              chienDichs={dm_chiendichs}
              onCancel={() => {
                setisShowAttendanceModal(false);
              }}
              hanleReloadDataSource={() => {
                handleReloadResults();
              }}
            />
          }
          {isShowDetailModal &&
            <DetailModal
              ts_form_register_result_details={ts_form_register_result_details}
              dm_chiendichs={dm_chiendichs}
              formEditor={formEditor}
              ts_form_items={ts_form_items_edit}
              item={selectedItem}
              onCancel={() => {
                setIsShowDetailModal(false);
              }}
              onSuccess={() => {
                setIsShowDetailModal(false);
                handeReloadData();
              }}
            />
          }
          {isShowSendEmailModal && <SendEmailInviteModal
            dataSource={dataSource}
            ts_form_items={ts_form_items}
            dm_chiendich_id={dm_chiendich_selected.id}
            chienDichs={dm_chiendichs}
            hanleReloadDataSource={() => {
              handleReloadResults();
            }}
            onCancel={() => {
              setIsShowSendEmailModal(false);
            }}
          />}
          {isShowSendEmailMoiGhiDanhModal && <SendEmailMoiGhiDanhModal
            dataSource={dataSource}
            ts_form_items={ts_form_items}
            dm_chiendich_id={dm_chiendich_selected.id}
            chienDichs={dm_chiendichs}
            hanleReloadDataSource={() => {
              handleReloadResults();
            }}
            onCancel={() => {
              setIsShowSendEmailMoiGhiDanhModal(false);
            }}
          />}
          {isShowImportModal && <FormResultImportModal
            onCancel={() => { setIsShowImportModal(false) }}
            onSuccess={() => {
              handleReloadResults();
              setIsShowImportModal(false)
            }}
          />}
          {showInSertModal && <PhuHuynhSelectTuVanVienModal
            onCancel={() => { setShowInSertModal(false) }}
            onSelected={handleUpdateTuVanVien}
            tuVanViens={tuVanViens}
          />}
          {/* {showInSertModal && <PhuHuynhSelectTuVanVienModal
            onCancel={() => { setShowInSertModal(false) }}
            onSelected={handleUpdateTuVanVien}
          />} */}
          {isShowEmailDetailModal &&
            <SendEmailModal
              selectedRowKeys={selectedRowKeys}
              dataSource={dataSource}
              username={user.username}
              onCancel={() => { setIsShowEmailDetailModal(false) }}
              onSuccess={() => { setIsShowEmailDetailModal(false) }}
            />
          }
          {isShowAddCampaignModal &&
            <AddCampaignModal
              selectedRowKeys={selectedRowKeys}
              ts_form_register_result_details={ts_form_register_result_details}
              dm_chiendichs={dm_chiendichs}
              ts_form_register_results={ts_form_register_results}
              onCancel={() => { setIsShowAddCampaignModal(false) }}
              onSuccess={() => {  handeReloadData(); 
                setIsShowAddCampaignModal(false) }}
            />
          }
          {isShowSmslDetailModal &&
            <SendSmsModal
              selectedRowKeys={selectedRowKeys}
              dataSource={dataSource}
              onCancel={() => { setIsShowSmsDetailModal(false) }}
              onSuccess={() => { setIsShowSmsDetailModal(false) }}
            />
          }
          {registerResult.id > 0 &&
            <Modal
              open={true}
              size='large'
              dimmer={'blurring'}
              closeIcon
              onClose={() => {
                setRegisterResult({ id: 0 });
              }}
              closeOnEscape={false}
              closeOnDimmerClick={false}
            >
              <Modal.Content>
                {/* <ScrollView height={window.innerHeight - 200}> */}
                <HocSinhProfile value={0} phuHuynh={0} registerResult={registerResult} height={window.innerHeight - 200} onReloadData={handeReloadData} />
                {/* </ScrollView> */}
              </Modal.Content>
            </Modal>
          }
          <HocSinhChangeStatusModal
						isOpen={isShowChangeStatusModal}
						onClose={() => {
							dispatch({
								type: actionTypes.CLOSE_CHANGE_STATUS_MODAL,
							});
						}}
						isSaving={false}
            isPhuHuynh={true}
						onSubmit={(dm_trangthaihocsinh_id) => {
							handleChangeStatus(dm_trangthaihocsinh_id);
						}}
						dm_coso_id={dm_coso_id}
					/>
        </div>
      </Transition>
    </React.Fragment>
  );
};

export default FormRegisterResultPage;
